export default {
  slug: "grazie",
  code: "GZ",
  label: "Grazie",
  krakenDir: "Grazie",
  logoFamily: "jb",
};
